import styled from 'styled-components';
import { media } from '@/styles/Qtheme';

interface DisabledRewardButtonProps {
  variant?: 'orange' | 'green' | 'greenSolid';
  onClick: () => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const StyledButton = styled.button<{ variant: string }>`
  margin-top: 6px;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  font-family: 'Pretendard';
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;

  /* Variant별 스타일 */
  ${({ variant }) => {
    switch (variant) {
      case 'orange':
        return `
          border: 1px solid #ff5c17;
          background: transparent;
          color: #ff5c17;

          &:hover {
            background-color: rgba(255, 92, 23, 0.1);
            transform: translateX(2px);
          }

          &:active {
            transform: translateX(0);
          }
        `;
      case 'green':
        return `
          border: 1px solid #0dcb81;
          background: transparent;
          color: #0dcb81;

          &:hover {
            background-color: rgba(13, 203, 129, 0.1);
            transform: translateX(2px);
          }

          &:active {
            transform: translateX(0);
          }
        `;
      case 'greenSolid':
        return `
          align-self: flex-start;
          width: 116px;
          height: 46px;
          border: none;
          background: #0abb76;
          color: #fff;
          margin-top: 0;

          &:hover {
            opacity: 0.9;
          }

          &:active {
            opacity: 0.8;
          }
        `;
      default:
        return '';
    }
  }}

  @media ${media.mobile} {
    font-size: 14px;
  }
`;

export const DisabledRewardButton: React.FC<DisabledRewardButtonProps> = ({
  variant = 'orange',
  onClick,
  children,
  style,
}) => {
  return (
    <StyledButton variant={variant} onClick={onClick} style={style}>
      {children}
    </StyledButton>
  );
};
